const enquiryForm = document.getElementById("enquiry-form");
const enquiryLinks = document.querySelectorAll(".enquiry-link");

const toggleEnquiryForm = () => {
	const ariaExpanded = enquiryForm.getAttribute("aria-expanded");
	document.body.classList.toggle("no-scroll", ariaExpanded === "false");
	if (ariaExpanded === "false") {
		enquiryForm.setAttribute("aria-expanded", "true");
		return;
	}
	enquiryForm.setAttribute("aria-expanded", "false");
};

Array.from(enquiryLinks)?.map((enquiryLink) => {
	enquiryLink.addEventListener("click", (e) => {
		e.preventDefault();
		toggleEnquiryForm();
	});
});
